import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  Cell,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { fetchClientAnalytics } from "../../redux/Slices/dashboardSlice";
import "../../styles/_client_analysis.scss";
import Loader from "../../components/Common/Loader";
import { normalizeDateForAPI } from "../../utils/Utils";

function Chart({ startDate, endDate }) {
  const dispatch = useDispatch();

  const { profileData } = useSelector((state) => state.profile);
  const coachId = profileData?.coachId;

  const { clientAnalytics, loading } = useSelector((state) => state.dashboard);

  useEffect(() => {
    if (coachId) {
      dispatch(
        fetchClientAnalytics({
          coachId,
          startDate: startDate ? normalizeDateForAPI(startDate) : null,
          endDate: endDate ? normalizeDateForAPI(endDate) : null,
        })
      );
    }
  }, [dispatch, startDate, endDate, coachId]);

  const chartData = clientAnalytics
    ? [
        { name: "Active", value: clientAnalytics.activeClients },
        { name: "Starting", value: clientAnalytics.startingClients },
        { name: "Ending", value: clientAnalytics.endingClients },
      ]
    : [];

  const colors = ["#383D8D", "#36C1A8", "#A42066"];

  if (loading) return <Loader />;

  if (!clientAnalytics) {
    return <div>No data available</div>;
  }

  return (
    <div className="card-client ">
      <div className="total-clients-container-client">
        <div className="website-hits-header ">
          {/* Title Section */}
          <div className="website-hits-title">
            <h1> Client Overview</h1>
          </div>

          {/* Total Hits Section */}
          <div className="website-hits-total">
            <h1>Total Clients</h1>
            <p className="total-hits-count">{clientAnalytics.totalClients}</p>
          </div>
        </div>

        <div className="chart-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} layout="vertical">
              <XAxis
                type="number"
                label={{
                  value: "No of Clients",
                  position: "bottom",
                  offset: -4,
                }}
              />
              <YAxis dataKey="name" type="category" />

              <Bar dataKey="value" fill="#8884d8" radius={[0, 12, 12, 0]}>
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % colors.length]}
                  />
                ))}
                <LabelList
                  dataKey="value"
                  position="insideRight"
                  fill="#FFFFFF"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default Chart;
